import Vue from 'vue'
import Vuex from 'vuex'
import api from './api'
import cookies from 'cookiesjs'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import customerTab from './modules/tabs/customerTabs'
import customer from './modules/customer'
import customerV2 from './modules/customerV2'
import customers from './modules/customers'
import prospects from './modules/prospects'
import contract from './modules/contract'
import consumptions from './modules/consumption'
import catalog from './modules/catalog'
import cart from './modules/cart'
import cash from './modules/cash'
import contractManagement from './modules/tabs/contractManagementSubTabs'
import user from './modules/user'
import activityDetector from 'utils/activity-detector'
import formResponseNotificator from 'utils/form-response-notificator'
import dashboard from './modules/dashboard'
import dashboardV2 from './modules/dashboardV2'
import demands from './modules/demands'
import validationRequestsV2 from './modules/validationRequestsV2'
import treatmentDemandTabs from './modules/tabs/treatmentDemandTabs'
import invoices from './modules/invoices'
import sandbox from './modules/sandbox'
import bookings from './modules/bookings'
import hotline from './modules/hotline'
import crm from './modules/crm'
import notifications from './modules/notifications'
import lps from './modules/loyaltyPrograms'
import beneficialOwners from './modules/beneficialOwners'

Vue.use(Vuex)

const state = {
  isLoggedIn: true,
  userEmail: cookies('defaultEmail'),
  fromRoute: {},
  agencies: [],
  organizations: [],
  isVisible: true,
  isActive: true,
  sapPromoCodes: [],

  formError: {},
  resourceForm: {
    uid: '',
    message: {
      update: {
        success: "Mis à jour avec succès.",
        error: "Erreur empêchant la mise a jour."
      },
      store: {
        success: "Créé avec succès.",
        error: "Erreur empêchant la création."
      },
      delete: {
        success: "Supprimé avec succès.",
        error: "Erreur empêchant la suppression."
      }
    },
    correspondingTypes: {
      "success": "complete-success",
      "error": "danger"
    },
    resource: null,
    method: null
  }
}

const store = new Vuex.Store({
  // strict mode when in dev mode
  // see (vuex doc #Strict Mode)
  // strict: process.env.NODE_ENV !== 'production',
  state,
  mutations,
  actions,
  getters,
  modules: {
    tabs: {
      namespaced: true, // provide a better nesting of TAB_ACTIVATION mutations
      modules: {
        customer: customerTab,
        contractManagement,
        treatmentDemandTabs,
      }
    },
    customers,
    prospects,
    customer,
    customerV2,
    user,
    contract,
    consumptions,
    catalog,
    cart,
    demands,
    validationRequestsV2,
    dashboard,
    dashboardV2,
    invoices,
    cash,
    sandbox,
    bookings,
    hotline,
    crm,
    notifications,
    lps,
    beneficialOwners
  },
  plugins: [activityDetector, formResponseNotificator],
})

if (module.hot) {

  const files = [
    './mutations',
    './actions',
    './getters',
    './modules/user',
    './modules/customers',
    './modules/prospects',
    './modules/customer',
    './modules/customerV2',
    './modules/contract',
    './modules/consumtion',
    './modules/tabs/customerTabs',
    './modules/tabs/contractManagementSubTabs',
    './modules/tabs/treatmentDemandTabs',
    './modules/catalog',
    './modules/cart',
    './modules/demands',
    './modules/validationRequestsV2',
    './modules/dashboard',
    './modules/dashboardV2',
    './modules/invoices',
    './modules/cash',
    './modules/sandbox',
    './modules/bookings',
    './modules/hotline',
    './modules/crm',
    './modules/notifications',
    './modules/loyaltyProgramSubscriptions'
  ]

  module.hot.accept(files, () => {
    const mutations = require('./mutations').default
    const actions = require('./actions').default
    const getters = require('./getters').default
    const user = require('./modules/user').default
    const customers = require('./modules/customers').default
    const customer = require('./modules/customer').default
    const customerV2 = require('./modules/customerV2').default
    const prospects = require('./modules/prospects').default
    const contract = require('./modules/contract').default
    const consumptions = require('./modules/consumption').default
    const contractManagement = require('./modules/tabs/contractManagementSubTabs').default
    const customerTab = require('./modules/tabs/customerTabs').default
    const catalog = require('./modules/catalog').default
    const cart = require('./modules/cart').default
    const demands = require('./modules/demands').default
    const validationRequestsV2 = require('./modules/validationRequestsV2').default
    const dashboard = require('./modules/dashboard').default
    const dashboardV2 = require('./modules/dashboardV2').default
    const invoices = require('./modules/invoices').default
    const cash = require('./modules/cash').default
    const treatmentDemandTabs = require('./modules/tabs/treatmentDemandTabs').default
    const sandbox = require('./modules/sandbox').default
    const bookings = require('./modules/bookings').default
    const hotline = require('./modules/hotline').default
    const crm = require('./modules/crm').default
    const notifications = require('./modules/notifications').default
    const lps = require('./modules/loyaltyPrograms').default

    store.hotUpdate({
      mutations,
      actions,
      getters,
      modules: {
        tabs: {
          namespaced: true, // provide a better nesting of TAB_ACTIVATION mutations
          modules: {
            customer: customerTab,
            contractManagement,
            treatmentDemandTabs,
          }
        },
        customers,
        prospects,
        customer,
        customerV2,
        user,
        contract,
        consumptions,
        catalog,
        cart,
        demands,
        validationRequestsV2,
        dashboard,
        dashboardV2,
        invoices,
        cash,
        sandbox,
        bookings,
        hotline,
        crm,
        notifications,
        lps
      },
      plugins: [activityDetector, formResponseNotificator],
    })
  })
}

export default store



// WEBPACK FOOTER //
// ./client/store/index.js